// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_k2-0";
export var discountCodeInput = "_k2-1";